var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModule8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7C10.6716 7 10 6.32843 10 5.5C10 4.67157 10.6716 4 11.5 4C12.3284 4 13 4.67157 13 5.5C12.9991 6.32805 12.3281 6.9991 11.5 7Z",
    fill: "#474C5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 0H3C1.34515 0.00483 0.00483 1.34515 0 3V11.86L3.88 7.98C5.06747 6.85 6.93253 6.85 8.12 7.98L10.9914 10.867L11.8789 9.97949C13.0524 8.81287 14.9476 8.81287 16.1211 9.97949L20 13.8584V3C19.9952 1.34515 18.6549 0.00483 17 0ZM11.5 7C10.6716 7 10 6.32843 10 5.5C10 4.67157 10.6716 4 11.5 4C12.3284 4 13 4.67157 13 5.5C12.9991 6.32805 12.328 6.9991 11.5 7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12 7.98031C6.93253 6.85031 5.06747 6.85031 3.88 7.98031L0 11.8603V17.0003C0.00484 18.6552 1.34516 19.9955 3 20.0003H17C17.8151 20 18.595 19.6678 19.16 19.0803L8.12 7.98031Z",
    fill: "#A2AACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 13.8584L16.1209 9.97944C14.9475 8.81284 13.0522 8.81284 11.8787 9.97944L10.9912 10.867L19.1555 19.0755C19.6976 18.5208 20.0007 17.7756 19.9998 17V13.8584Z",
    fill: "#474C5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule8);
export default __webpack_public_path__ + "static/media/module_8.0e4892af77a828244d0cdfe1397a0223.svg";
export { ForwardRef as ReactComponent };